module.exports = __webpack_public_path__ + "static/media/metamask-deposit.dd279a6a.png";